module.exports = __webpack_public_path__ + "static/media/girl-18.b40d446e.svg";